module.exports = __webpack_public_path__ + "media/images/service/a_3-95482a4a5ce4cbf6b93004a39f7d5c79.png";